import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClinicProductService {
  private clinicProductsSubject = new BehaviorSubject<any[]>([]);
  public clinicProducts$ = this.clinicProductsSubject.asObservable();

  private ordersSubject = new Subject<any[]>();
  public orders$ = this.ordersSubject.asObservable();

  constructor(
    private api: ApiService
  ) { }

  updateOrders(orders: any[]) {
    this.ordersSubject.next(orders);
  }

  getClinicProducts(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams,
      };
    }
    return this.api.getAPI('clinic-products', queryParams);
  }

  createOrder(clinic_id: any, order: any) {
    return this.api.postAPI(`clinic-products/${clinic_id}/create-sales-order`, order);
  }

  getOrders(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams,
      };
    }
    return this.api.getAPI('clinic-products/sales-orders', queryParams);
  }

  getClinicOrders(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams,
      };
    }
    return this.api.getAPI(`clinic-products/clinic-orders`, queryParams);
  }

  getSalesOrderCount() {
    return this.api.getAPI('clinic-products/sales-order-count');
  }

  toggleClinicProduct(productId: any) {
    return this.api.updateAPI(`clinic-products/${productId}/toggle-active`);
  }

  getAllClinicProducts(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams,
      };
    }
    return this.api.getAPI('clinic-products/all', queryParams);
  }

  createClinicProduct(product: any) {
    return this.api.postAPI('clinic-products/create-clinic-product', product);
  }
}
